(function () {
  const SECTION_SELECTOR = '[data-video-banner]';
  const BREAKPOINT = '(min-width: 990px)';

  const mediaQuery = window.matchMedia ? window.matchMedia(BREAKPOINT) : null;
  const instances = new WeakMap();

  class VideoBannerController {
    constructor(section) {
      this.section = section;
      this.layout = section.querySelector('[data-video-banner-layout]');
      this.media = section.querySelector('.VideoBanner__media');
      this.content = section.querySelector('.VideoBanner__content');
      this.iframe = section.querySelector('.VideoBanner__embed iframe');

      if (!this.layout || !this.media || !this.content) {
        return;
      }

      this.layoutType = this.layout.dataset.videoBannerLayout || 'full';
      this.videoRatio = parseFloat(this.layout.dataset.videoRatio || '1') || 1;
      this.contentRatio = parseFloat(this.layout.dataset.contentRatio || '1') || 1;

      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
      this.handleResize = this.handleResize.bind(this);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.content);
      } else {
        this.fallbackResize = true;
        window.addEventListener('resize', this.handleResize);
      }

      if (mediaQuery) {
        if (mediaQuery.addEventListener) {
          mediaQuery.addEventListener('change', this.handleBreakpointChange);
        } else if (mediaQuery.addListener) {
          mediaQuery.addListener(this.handleBreakpointChange);
        }
      }

      window.addEventListener('orientationchange', this.handleResize);

      this.applyHeights();
    }

    isSplitLayout() {
      return this.layoutType !== 'full';
    }

    handleBreakpointChange() {
      this.applyHeights();
    }

    handleResize() {
      this.applyHeights();
    }

    applyHeights() {
      if (!this.isSplitLayout()) {
        this.resetHeight();
        this.applyIframeCover();
        return;
      }

      if (mediaQuery && mediaQuery.matches) {
        this.resetHeight();
        this.applyIframeCover();
        return;
      }

      const contentHeight = this.content.getBoundingClientRect().height;
      if (!contentHeight) {
        this.resetHeight();
        this.applyIframeCover();
        return;
      }

      const ratio = this.contentRatio === 0 ? 1 : this.videoRatio / this.contentRatio;
      const targetHeight = Math.max(contentHeight * ratio, 0);

      this.media.style.height = `${targetHeight}px`;
      this.applyIframeCover();
    }

    resetHeight() {
      this.media.style.height = '';
    }

    applyIframeCover() {
      if (!this.iframe) {
        return;
      }

      const wrapper = this.iframe.parentElement;
      if (!wrapper) {
        return;
      }

      const rect = wrapper.getBoundingClientRect();
      const width = rect.width;
      const height = rect.height;

      if (!width || !height) {
        this.resetIframeCover();
        return;
      }

      const containerRatio = width / height;
      const targetRatio = 16 / 9;
      const scale = Math.max(containerRatio / targetRatio, targetRatio / containerRatio);

      this.iframe.style.width = '100%';
      this.iframe.style.height = '100%';
      this.iframe.style.transformOrigin = '50% 50%';
      this.iframe.style.transform = `translate(-50%, -50%) scale(${scale})`;
    }

    resetIframeCover() {
      if (!this.iframe) {
        return;
      }
      this.iframe.style.width = '';
      this.iframe.style.height = '';
      this.iframe.style.transformOrigin = '';
      this.iframe.style.transform = '';
    }

    destroy() {
      this.resetHeight();
      this.resetIframeCover();
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      if (mediaQuery) {
        if (mediaQuery.removeEventListener) {
          mediaQuery.removeEventListener('change', this.handleBreakpointChange);
        } else if (mediaQuery.removeListener) {
          mediaQuery.removeListener(this.handleBreakpointChange);
        }
      }
      window.removeEventListener('orientationchange', this.handleResize);
      if (this.fallbackResize) {
        window.removeEventListener('resize', this.handleResize);
      }
    }
  }

  function initSection(section) {
    destroySection(section);
    const controller = new VideoBannerController(section);
    if (controller.layout) {
      instances.set(section, controller);
    }
  }

  function destroySection(section) {
    const controller = instances.get(section);
    if (controller) {
      controller.destroy();
      instances.delete(section);
    }
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target?.querySelectorAll?.(SECTION_SELECTOR).forEach(initSection);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target?.querySelectorAll?.(SECTION_SELECTOR).forEach(destroySection);
  });
})();
